import { render, staticRenderFns } from "./WorkerInfo.vue?vue&type=template&id=47fb255a&"
import script from "./WorkerInfo.vue?vue&type=script&lang=js&"
export * from "./WorkerInfo.vue?vue&type=script&lang=js&"
import style0 from "./WorkerInfo.vue?vue&type=style&index=0&id=47fb255a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports